module.exports = __webpack_public_path__ + "media/svg-new/banned-e572cd74.svg";